import {
  AddProductsToPricelistModalTranslation,
  DeletePricelistTranslation,
  EditPricelistTranslation,
  ExportPricelistToExcelModalTranslation,
  ExportPricelistToPdfModalTranslation,
  IncludeNetPriceTranslation,
  ModuleTranslation,
  NetPriceTranslation,
  PricelistDetailsTranslation,
  PricelistFormTranslation,
  PricelistsTranslation,
  ProductAccessoriesTranslation,
  ProductDetailsTranslation,
  ProductImageTranslation,
  ProductPricelistTranslation,
} from './ModuleTranslation';

const pricelistForm: PricelistFormTranslation = {
      name: {
        label: 'Name',
        placeholder: 'Enter name',
        maxLengthError: 'The name cannot be longer than {maxLength} characters.',
        requiredError: 'Please enter a name.',
      },
      description: {
        label: 'Description',
        placeholder: 'Enter short description',
        maxLengthError: 'The description cannot be longer than {maxLength} characters.',
      },
  errors: {
    createFailed: 'The price list could not be created. Please try again.',
    updateFailed: 'The price list could not be saved. Please try again.',
    nameAlreadyExists: 'Price list with this name already exists. Please use a different name.',
  },
};

const addToPricelistModal: AddProductsToPricelistModalTranslation = {
  triggerLabel: 'Add to My Price Lists',
  closeLabel: 'Close',
  heading: 'Add to My Price Lists',
  itemsToAddFormat: '{count} items will be added',
  addedToPricelistFormat: 'Added {count} items to "{name}"',
  loadingLabel: 'Loading price lists',
  modeLabel: 'Add the selected products to an existing price list or to a new one',
  modes: {
    existing: 'Add to existing',
    new: 'Create new',
  },
  cancelLabel: 'Cancel',
  addLabel: 'Add',
  addPendingLabel: 'Adding…',
  createLabel: 'Create',
  createPendingLabel: 'Creating…',
  selectForm: {
    label: 'Select price list',
    addFailedError: 'The products could not be added to the price list. Please try again.',
  },
  createForm: pricelistForm,
};

const netPrice: NetPriceTranslation = {
  label: 'Net price',
  notAvailable: 'N/A',
};

const productAccessories: ProductAccessoriesTranslation = {
  basePrice: 'Base price',
  itemNo: 'Item no',
  name: 'Description',
  price: 'Price',
  priceOnDemand: 'on demand',
  netPrice,
};

const productPricelist: ProductPricelistTranslation = {
  basePrice: 'Base price',
  heading: 'Price list',
  price: 'Price',
  priceGroup: 'Price group',
  priceOnDemand: 'on demand',
  netPrice,
};

const productImage: ProductImageTranslation = {
  enlargeImageFormat: 'Enlarge image of {name}',
};

const includeNetPrice: IncludeNetPriceTranslation = {
  label: 'Include net prices',
  noAgreementsReason: 'No dealer agreements are available.',
};

const exportToExcelModal: ExportPricelistToExcelModalTranslation = {
  closeLabel: 'Close',
  heading: 'Excel export',
  generatingLabel: 'Please wait for the file to be created.',
  readyLabel: 'Your file is ready.',
  errorLabel: 'The file could not be created. Please try again.',
  exportLabel: 'Export',
  downloadLabel: 'Download',
  includeNetPrice,
};

const exportToPdfModal: ExportPricelistToPdfModalTranslation = {
  closeLabel: 'Close',
  heading: 'PDF export',
  titleInputLabel: 'Title',
  titleInputPlaceholder: 'Enter title',
  titleSubmitLabel: 'Update',
  loadingDataLabel: 'Please wait for the products to load.',
  generatingLabel: 'Please wait for the file to be created.',
  readyLabel: 'Your file is ready.',
  errorLabel: 'The file could not be created. Please try again.',
  downloadLabel: 'Download',
  includeNetPrice,
  document: {
    coverPage: {
      heading: 'Price list',
      createdAtLabel: 'Created',
      itemsLabel: 'Items',
    },
    productSection: {
      itemNoLabel: 'Item no',
      detailsHeading: 'Product details',
      pricelist: productPricelist,
      additionalInfoHeading: 'Additional information',
      accessories: {
        heading: 'Accessories',
        table: productAccessories,
      },
    },
  },
};

const editPricelist: EditPricelistTranslation = {
  label: 'Edit',
  modal: {
    closeLabel: 'Close',
    heading: 'Edit Price List',
    cancelLabel: 'Cancel',
    submitLabel: 'Save',
    submitPendingLabel: 'Saving…',
    form: pricelistForm,
  },
};

const deletePricelist: DeletePricelistTranslation = {
  label: 'Delete',
  confirmationFormat: 'Are you sure you want to delete "{name}"? This cannot be undone.',
  successFormat: 'Deleted "{name}"',
  modal: {
    closeLabel: 'Close',
    heading: 'Delete Price List',
    cancelLabel: 'Cancel',
    confirmLabel: 'Delete',
    confirmPendingLabel: 'Deleting…',
    error: 'The price list could not be deleted. Please try again.',
  },
};

const pricelists: PricelistsTranslation = {
  pageTitleFormat: 'Price Lists',
  pageDescriptionFormat: 'Browse your price lists',
  tabs: {
    products: 'Products',
    pricelists: 'My Price Lists',
  },
  pricelistListing: {
    searchPlaceholder: 'Search',
    listsFoundLabel: 'Lists found',
    loadingLabel: 'Loading price lists',
    loadingMoreLabel: 'Loading more price lists',
    pricelistList: {
      pricelistListingEmpty: {
        message: 'No price lists found',
        createLabel: 'Create a price list',
      },
      pricelistListingItem: {
        itemsLabel: 'Items:',
        createdAtLabel: 'Created:',
        modifiedAtLabel: 'Last edited:',
        actionsLabelFormat: 'Actions for {name}',
      },
      itemActions: {
        edit: editPricelist,
        delete: deletePricelist,
      },
    },
    createPricelistModalTriggerLabel: 'New price list',
    createPricelistModal: {
      closeLabel: 'Close',
      heading: 'Create New Price List',
      cancelLabel: 'Cancel',
      submitLabel: 'Create',
      submitPendingLabel: 'Creating…',
      form: pricelistForm,
    },
  },
  productListing: {
    title: 'Price Lists',
    searchPlaceholder: 'Search',
    expansionToggle: {
      label: 'Expand or collapse all product families',
      options: {
        collapseAll: 'Collapse all',
        expandAll: 'Expand all',
      },
    },
    productsFoundLabel: 'Products found',
    filters: {
      heading: 'Filters',
      brands: {
        label: 'Brand',
      },
      types: {
        label: 'Type',
      },
      sectors: {
        label: 'Space',
      },
      priceRange: {
        label: 'Price',
        range: {
          from: 'From',
          to: 'To',
        },
      },
    },
    table: {
      title: 'Products',
      emptyText: 'No products found',
      loadingLabel: 'Loading products',
      loadingMoreLabel: 'Loading more products',
      selectAll: 'Select all products',
      selectProduct: 'Select',
      expandFamily: 'Show products',
      collapseFamily: 'Hide products',
      expandColumnLabel: 'Expand',
      itemNo: 'Item no',
      image: 'Image',
      productImage,
      brand: 'Brand',
      model: 'Model',
      price: 'Price',
      priceInfo: {
        label: 'Price information',
        content: 'Starting prices. Prices vary by selected fabrics and options.',
      },
      fromLabel: 'from',
      productsCountLabel: 'products',
      newBadge: 'NEW',
      modelActionLabel: 'Pricing',
      familyActionLabel: 'Info',
      actionLabel: 'Action',
    },
    selectionPanel: {
      selectedCountFormat: '{count} items selected',
      export: 'Export',
      clearSelection: 'Clear selection',
    },
    addToPricelistModal,
    exportToPdfModal,
    details: {
      closeLabel: 'Close',
      loadingLabel: 'Loading family details',
      specificationHeading: 'Specification',
    },
    modelDetails: {
      closeLabel: 'Close',
      loadingLabel: 'Loading pricing',
      pricelist: {
        caption: 'Price list',
        productGroup: 'PG',
        basePrice: 'Base price',
        price: 'Price',
        priceOnDemand: 'on demand',
        agreementDiscount: 'Dealer agreement discount',
        netPrice,
      },
      detailsLinkLabel: 'Go to product page to view detailed pricing',
    },
  },
};

const productDetails: ProductDetailsTranslation = {
  pageTitleFormat: '',
  pageDescriptionFormat: 'Prices and accessories for {name}',
  backlinkLabel: 'Back',
  downloadLabel: 'Download',
  lastUpdatedLabel: 'Last updated:',
  itemNoLabel: 'Item no',
  addToPricelistModal,
  exportToPdfModal,
  familyDetails: {
    triggerLabel: 'Family details',
    closeLabel: 'Close',
    descriptionHeading: 'Description',
    featuresHeading: 'Features',
  },
  terms: {
    triggerLabel: 'Terms',
    closeLabel: 'Close',
    heading: 'General sales and delivery terms',
    introFormat: 'This document applies for contracted distributors of {brand}.',
    loadingLabel: 'Loading terms',
  },
  closeLabel: 'Close',
  productDetailsHeading: 'Product details',
  accessoriesHeading: 'Accessories',
  additionalInfoHeading: 'Additional information',
  pricelist: productPricelist,
  accessories: productAccessories,
};

const pricelistDetails: PricelistDetailsTranslation = {
  pageTitleFormat: '',
  pageDescriptionFormat: 'Prices for the products on {name}',
  backlinkLabel: 'Back',
  exportLabel: 'Excel',
  downloadLabel: 'PDF/Print',
  settingsLabel: 'Settings',
  itemsLabel: 'Items:',
  createdAtLabel: 'Created:',
  modifiedAtLabel: 'Last edited:',
  regionLabel: 'Region',
  currencyLabel: 'Currency',
  pricesRefreshedAtLabel: 'Prices refreshed',
  currencyExcludingVatFormat: '{currency} (excl. VAT)',
  searchPlaceholder: 'Search',
  productsLabel: 'Products on this price list',
  itemsFoundLabel: 'Items',
  emptyText: "No items found",
  loadingLabel: 'Loading items',
  loadingMoreLabel: 'Loading more items',
  exportToExcelModal,
  exportToPdfModal,
  product: {
    actionsLabelFormat: 'Actions for {name}',
    pricelist: productPricelist,
    productImage,
    additionalInfoHeading: 'Additional information',
    accessories: {
      heading: 'Accessories',
      loadingLabel: 'Loading accessories',
      table: productAccessories,
    },
  },
  pricelistActions: {
    edit: editPricelist,
    delete: deletePricelist,
  },
  productActions: {
    remove: {
      label: 'Remove',
      confirmationFormat: 'Are you sure you want to remove "{name}" from this price list?',
      successFormat: 'Removed "{name}"',
      modal: {
        closeLabel: 'Close',
        heading: 'Remove Product',
        cancelLabel: 'Cancel',
        confirmLabel: 'Remove',
        confirmPendingLabel: 'Removing…',
        error: 'The product could not be removed. Please try again.',
      },
    },
  },
};

const translation: ModuleTranslation = {
  pricelistDetails,
  pricelists,
  productDetails,
};

export default translation;
